const features = [
  {
    icon: 'ri-book-open-line',
    title: '海量漫画资源',
    desc: '50000+部韩漫、日漫、国漫免费全集在线阅读，热门推荐不间断更新，漫画大全尽在掌握。',
  },
  {
    icon: 'ri-arrow-down-line',
    title: '下拉式阅读',
    desc: '流畅的下拉式漫画阅读体验，无需翻页等待，一气呵成畅快追漫，让好看的故事停不下来。',
  },
  {
    icon: 'ri-device-line',
    title: '全设备适配',
    desc: '电脑、平板、手机完美兼容，随时随地打开亲亲漫画即可继续阅读，进度自动同步。',
  },
  {
    icon: 'ri-translate',
    title: '多语种覆盖',
    desc: '韩漫、日漫、国漫原版与汉化版同步上线，专业翻译团队保证阅读品质，原汁原味呈现。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '纯净阅读环境，无弹窗无恶意广告骚扰。亲亲漫画专注内容本身，守护你的每一次阅读体验。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8">
          平台特色
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="p-5 rounded-xl bg-background-100/80 border border-background-200/70 hover:border-primary-200/50 transition-all group"
            >
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feat.icon} text-accent-600 text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}